import axios from "@/axios";

export default {
  namespaced: true,
  state: {
    loading: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
  },
  mutations: {
    RESET(state) {
      state.loading = false;
    },
    SET_LOADING(state, payload) {
      state.loading = payload;
    },
  },
  actions: {
    reset({ commit }) {
      commit("RESET");
    },
    changePassword({ commit }, { currentPassword, plainPassword }) {
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);
        axios
          .post("/users/change_password", { currentPassword, plainPassword })
          .then((response) => {
            if (response.status === 200) {
              resolve();
            } else {
              reject(new Error("Unexpected response status"));
            }
          })
          .catch((error) => reject(error))
          .finally(() => commit("SET_LOADING", false));
      });
    },
    updateUser({ commit }, user) {
      if (!user || !user.uuid) return null;
      return new Promise((resolve, reject) => {
        commit("SET_LOADING", true);

        axios
          .patch(`/users/${user.uuid}`, user, {
            headers: {
              "Content-Type": "application/merge-patch+json",
            },
          })
          .then((response) => {
            if (response.status === 200) {
              localStorage.setItem(
                "foravilaProvidersUserData",
                JSON.stringify(response.data)
              );
              resolve(response.data);
            } else {
              reject(
                new Error(
                  "The request was successfull, but the received status was not the expected one"
                )
              );
            }
          })
          .catch((error) => {
            // TODO: log the error with Sentry
            reject(error);
          })
          .finally(() => commit("SET_LOADING", false));
      });
    },
  },
};
